(function () {
  const PRODUCT_CONFIGS = {
    'maltese-balcony-wall-deco-version': {
      colourImagePatterns: {
        blue: ['product_balcony_deco_blue'],
        'light blue': ['product_balcony_deco_light_blue'],
        green: ['product_balcony_deco_green', 'mbgreen'],
        'dark green': ['product_balcony_deco_dark_green'],
        red: ['product_balcony_deco_red'],
        'dark red': ['product_balcony_deco_dark_red'],
        yellow: ['product_balcony_deco_yellow'],
        pink: ['product_balcony_deco_bright_pink'],
        orange: ['product_balcony_deco_orange'],
        purple: ['maltese-balcony-wall-decoration'],
        black: ['maltese-balcony-wall-decoration']
      }
    },
    'maltese-balcony-key-hanger-version': {
      colourImagePatterns: {
        blue: ['balcony_key_hanger_blue'],
        orange: ['123.png', '8.jpg'],
        purple: ['123.png', '8.jpg'],
        yellow: ['balcony_deco_yellow'],
        red: ['balcony_key_hanger_dark_red'],
        green: ['balcony_key_hanger_green'],
        pink: ['balcony_key_hanger_bright_pink']
      }
    },
    'maltese-door-deco': {
      colourImagePatterns: {
        yellow: ['door_yellow', 'productdoor77beigeyellowandgold'],
        green: ['door_green', 'productdoorgreenandwhite'],
        blue: ['door_blue', 'productdoor77whiteblueandwhite'],
        orange: ['productdoor77beigeyellowandgold', 'door_yellow'],
        red: ['door_red', 'productdoor79beigeredandwhite'],
        purple: ['productdoor77beigeyellowandgold', 'door_green']
      }
    },
    'knight-statue-figurine': {
      colourImagePatterns: {
        bronze: ['knightofmalta7', 'knightofmalta6', 'knightofmaltaproductimage'],
        silver: ['knightofmalta2', 'knightofmalta6', 'knightofmaltaproductimage'],
        gold: ['652660712', '651654359']
      }
    },
    'sea-snail-table-decoration': {
      colourImagePatterns: {
        beige: ['snailtransperant'],
        red: ['snailred'],
        blue: ['snailblue'],
        yellow: ['snailyellow'],
        green: ['snailtransperant'],
        translucent: ['snailtransperant']
      }
    },
    'maltese-cross-stash-box-set': {
      colourImagePatterns: {
        transparent: ['maltese-cross-stash-box-transparent-closed'],
        red: ['maltese-cross-stash-box-red-closed']
      }
    }
  };

  const normalise = (value) => String(value || '').trim().toLowerCase();

  const currentHandle = Object.keys(PRODUCT_CONFIGS).find((handle) =>
    window.location.pathname.includes(`/products/${handle}`)
  );
  const currentConfig = PRODUCT_CONFIGS[currentHandle];
  if (!currentConfig) return;

  const COLOUR_IMAGE_PATTERNS = currentConfig.colourImagePatterns;

  const findColourFromVariant = (variant) => {
    if (!variant) return '';

    const options = Array.isArray(variant.options) ? variant.options : [];
    const explicitColour = [variant.option1, variant.option2, variant.option3, ...options]
      .map(normalise)
      .find((value) => Object.prototype.hasOwnProperty.call(COLOUR_IMAGE_PATTERNS, value));

    return explicitColour || '';
  };

  const findGalleryMediaId = (colour) => {
    const patterns = COLOUR_IMAGE_PATTERNS[colour];
    const gallery = document.querySelector('media-gallery');
    if (!patterns || !gallery) return '';

    const mediaItems = Array.from(gallery.querySelectorAll('li[data-media-id]'));
    const match = patterns
      .map((pattern) =>
        mediaItems.find((item) => {
          const image = item.querySelector('img');
          const source = normalise(image?.currentSrc || image?.src || '');
          return source.includes(pattern);
        })
      )
      .find(Boolean);

    return match?.dataset?.mediaId || '';
  };

  const activateColourImage = (colour) => {
    const gallery = document.querySelector('media-gallery');
    const mediaId = findGalleryMediaId(colour);
    if (!gallery || !mediaId) return;

    if (typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(mediaId, true);
      return;
    }

    const activeMedia = gallery.querySelector(`li[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;

    gallery.querySelectorAll('li[data-media-id]').forEach((item) => item.classList.remove('is-active'));
    activeMedia.classList.add('is-active');
    activeMedia.parentElement?.scrollTo({ left: activeMedia.offsetLeft, behavior: 'smooth' });

    const activeThumbnail = gallery.querySelector(`[data-target="${mediaId}"]`);
    if (!activeThumbnail) return;

    gallery
      .querySelectorAll('[data-target] button[aria-current]')
      .forEach((button) => button.removeAttribute('aria-current'));
    activeThumbnail.querySelector('button')?.setAttribute('aria-current', 'true');
  };

  const activateCurrentSelection = () => {
    const selectedVariantJson = document.querySelector('variant-selects [data-selected-variant]');
    if (!selectedVariantJson?.textContent?.trim()) return;

    try {
      const variant = JSON.parse(selectedVariantJson.textContent);
      activateColourImage(findColourFromVariant(variant));
    } catch (error) {
      return;
    }
  };

  const onVariantChange = (event) => {
    if (!event?.data?.variant) return;
    window.setTimeout(() => {
      activateColourImage(findColourFromVariant(event.data.variant));
    }, 80);
  };

  const onOptionChange = (event) => {
    const target = event.target;
    if (!target?.closest?.('variant-selects')) return;
    window.setTimeout(activateCurrentSelection, 450);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  document.addEventListener('change', onOptionChange);
  document.addEventListener('DOMContentLoaded', () => window.setTimeout(activateCurrentSelection, 250));
  window.addEventListener('pageshow', () => window.setTimeout(activateCurrentSelection, 250));
})();
